import { render, staticRenderFns } from "./saCompanyInfo.vue?vue&type=template&id=0f6e845a&scoped=true&"
import script from "./saCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./saCompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./saCompanyInfo.vue?vue&type=style&index=0&id=0f6e845a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6e845a",
  null
  
)

export default component.exports